import { useQuery } from '@tanstack/react-query'
import { pantryNavigationApis } from '../gateways/breadstack/pantryNavigationApis'
import { readNavCache, writeNavCache } from '../providers/navCacheStorage'
import type { PantryNavApiResponse } from '../types/pantryNavigation'

export const PANTRY_NAVIGATION_QUERY_KEY = 'pantryNavigation' as const

interface UsePantryNavigationOptions {
  enabled?: boolean
}

export const usePantryNavigation = (
  storeId: string | undefined,
  options: UsePantryNavigationOptions = {},
) =>
  useQuery<PantryNavApiResponse | null>({
    queryKey: [PANTRY_NAVIGATION_QUERY_KEY, storeId],
    queryFn: async () => {
      if (!storeId) return null
      const data = await pantryNavigationApis.get(storeId)
      if (data) writeNavCache(storeId, data)
      return data
    },
    // Seed the query with the last successfully fetched response from
    // localStorage so a hard refresh / workspace switch renders the navbar
    // instantly instead of falling back to SAFE_FALLBACK_SECTIONS.
    initialData: () => readNavCache(storeId) ?? undefined,
    // Force the seeded value to be treated as stale so React Query still
    // triggers a background refetch on mount.
    initialDataUpdatedAt: () => (readNavCache(storeId) ? 0 : undefined),
    staleTime: 5 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
    retry: 3,
    enabled: Boolean(storeId) && (options.enabled ?? true),
  })
